import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CasePipe } from 'src/app/pipes/case.pipe';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-profile-image',
  standalone: true,
  imports: [CommonModule, CasePipe],
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss'],
})
export class ProfileImageComponent {
  @Input() smallSize = false;
  @Input() largeSize = false;
  @Input() fontSize: string | null = null;
  backgroundColor!: string;
  imageId!: string | null;

  private _imageId: string | null = null;
  set image(value: string | null) {
    this.imageId = value;
    this._imageId = environment.apiUrl + '/api/s3/downloads/' + value + '/image';
  }

  @Input() public get image(): string | null {
    return this._imageId;
  }

  set firstName(value: string | null) {
    this.backgroundColor = this.generateRandomDarkColor(value || '');
    this._firstName = value;
  }

  @Input() public get firstName(): string | null {
    return this._firstName;
  }

  set lastName(value: string | null) {
    this.backgroundColor = this.generateRandomDarkColor(value || '');
    this._lastName = value;
  }

  @Input() public get lastName(): string | null {
    return this._lastName;
  }

  private _lastName: string | null = null;
  private _firstName: string | null = null;

  generateRandomDarkColor(username: string): string {
    let hash = 0;
    for (let i = 0; i < username.length; i++) {
      hash = username.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash % 360);
    const saturation = 58;
    const lightness = 58;

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }
}
